import { ShieldCheck } from "lucide-react";

const pill = (v) => (v === "Up" || v === "Aligned" ? "bg-emerald-500/15 text-emerald-300"
  : v === "Down" ? "bg-red-500/15 text-red-300" : "bg-[#1A2338] text-slate-200");

export const SignalFilterCard = ({ live }) => {
  const f = live?.result?.signal_filter;
  if (!f) return null;
  const none = f.signal === "WAIT";
  return (
    <section className="card p-5 sm:p-6 fade-up" data-testid="signal-filter-card">
      <h2 className="font-head font-bold text-lg flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-[#34D399]" /> Signal quality filter</h2>
      <div className="mt-3 divide-y divide-[#1A2338] text-sm">
        <div className="flex justify-between items-center py-2.5">
          <span className="text-slate-400">BTC direction</span>
          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${pill(f.btc_direction)}`} data-testid="filter-direction">{f.btc_direction}</span>
        </div>
        <div className="flex justify-between items-center py-2.5">
          <span className="text-slate-400">Timeframes (1m · 5m · 15m)</span>
          <span className="font-semibold" data-testid="filter-timeframes">{f.timeframes}</span>
        </div>
        <div className="flex justify-between items-center py-2.5">
          <span className="text-slate-400">Signal status</span>
          <span className={`px-3 py-1 rounded-full text-xs font-bold ${none ? "bg-orange-500/15 text-orange-400" : f.signal === "UP" ? "bg-emerald-500/15 text-emerald-300" : "bg-red-500/15 text-red-300"}`} data-testid="filter-signal">{f.signal}</span>
        </div>
      </div>
      <p className="text-sm text-slate-400 mt-3 leading-relaxed" data-testid="filter-explanation">{f.explanation}</p>
      {none && f.candidate && <p className="text-xs text-blue-300 mt-2" data-testid="filter-candidate">Candidate {f.candidate} logged for the track record (no alert until validated).</p>}
      <ul className="mt-3 space-y-1 text-xs" data-testid="filter-criteria">
        {f.criteria.map((c) => (
          <li key={c.name} className={c.met ? "text-emerald-300" : "text-slate-500"}>{c.met ? "✓" : "✗"} {c.name}</li>
        ))}
      </ul>
    </section>
  );
};
